import StringColumn from "@isceco/widget-library2/basic-elements/List/column/StringColumn.js";
import GenericColumn from "@isceco/widget-library2/basic-elements/List/column/GenericColumn.js";
import DateTimeCell from "@isceco/widget-library2/basic-elements/List/cell/DateTimeCell.js";
import DateCell from "@isceco/widget-library2/basic-elements/List/cell/DateCell.js";

export default class AuditlogColumns {

  static FIELD_NAME_COLUMN() {
    return new StringColumn({
      key: 'fieldName',
      text: 'admin.auditlog.table.fieldName',
      sortable: true
    })
  }

  static BILANZ_ZONE_COLUMN() {
    return new StringColumn({
      key: 'bilanzZone',
      text: 'admin.auditlog.table.bilanzZone',
      sortable: true,
      weight: 0.8
    })
  }

  static DATE_COLUMN() {
    return new GenericColumn({
      key: 'date',
      text: 'admin.auditlog.table.date',
      sortable: true,
      cell: new DateCell(),
      weight: 0.8
    })
  }

  static EINSPEISEPUNKT_COLUMN() {
    return new StringColumn({
      key: 'einspeisepunkt',
      text: 'admin.auditlog.table.einspeisepunkt',
      sortable: true
    })
  }

  static MONAT_COLUMN() {
    return new StringColumn({
      key: 'monat',
      text: 'admin.auditlog.table.monat',
      sortable: true
    })
  }

  static OLD_VALUE_COLUMN() {
    return new StringColumn({
      key: 'oldValue',
      text: 'admin.auditlog.table.oldValue',
      sortable: false
    })
  }

  static NEW_VALUE_COLUMN() {
    return new StringColumn({
      key: 'newValue',
      text: 'admin.auditlog.table.newValue',
      sortable: false
    })
  }

  static CHANGE_USER_COLUMN() {
    return new StringColumn({
      key: 'changeUser',
      text: 'admin.auditlog.table.changeUser',
      sortable: true
    })
  }

  static CHANGE_DATE_COLUMN() {
    return new GenericColumn({
      key: 'changeDate',
      text: 'admin.auditlog.table.changeDate',
      sortable: true,
      cell: new DateTimeCell()
    })
  }
}
